import { render, staticRenderFns } from "./aboutModal.vue?vue&type=template&id=2ce5b1ca&scoped=true&"
import script from "./aboutModal.vue?vue&type=script&lang=js&"
export * from "./aboutModal.vue?vue&type=script&lang=js&"
import style0 from "./aboutModal.vue?vue&type=style&index=0&id=2ce5b1ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce5b1ca",
  null
  
)

export default component.exports